module.exports = __webpack_public_path__ + "img/2_284.d6d90754.png";